jQuery(function(){

    var passengerCount = 2;
    var otherPassengerCount = 2;
    var witnessCount = 2;

    jQuery('body').on('click', '.auto-loss-form__add-passenger-link', function(){
        var get = { };

        get.passenger_count = passengerCount;

        jQuery.get('/api/add-passenger', get, function(response){

            jQuery('.auto-loss-form__passenger-container').append(response);
            jQuery('.text-field--phone').mask('000-000-0000');
            passengerCount++;
        });

        return false;
    });

    jQuery('body').on('click', '.auto-loss-form__remove-button', function(e){
        e.preventDefault();
        jQuery(this).closest('.auto-loss-form__new-passsenger-container').remove();
        passengerCount--;

        jQuery('.auto-loss-form__new-passsenger-container').each(function(index, container) {

            var $container = jQuery(container);

            $container.find('.input__text-container').find('.label').each(function(i, ele){
                var $ele = jQuery(ele);
                $ele.text($ele.text().replace(/\d/g, function(a,n){
                    return index + 2;
                }));
            });

        });


        return false;
    });

    if (jQuery('.text-field--phone').length) {
        jQuery('.text-field--phone').mask('000-000-0000');
    }

    jQuery('body').on('click', '.auto-loss-form__add-other-passenger-link', function(){
        var get = { };

        get.passenger_count = otherPassengerCount;

        jQuery.get('/api/add-other-passenger', get, function(response){

            jQuery('.auto-loss-form__other-passenger-container').append(response);
            jQuery('.text-field--phone').mask('000-000-0000');
            otherPassengerCount++;
        });

        return false;
    });

    jQuery('body').on('click', '.auto-loss-form__remove-other-button', function(e){
        e.preventDefault();

        jQuery(this).closest('.auto-loss-form__new-other-passenger-container').remove();
        otherPassengerCount--;

        jQuery('.auto-loss-form__new-other-passenger-container').each(function(index, container) {

            var $container = jQuery(container);

            $container.find('.input__text-container').find('.label').each(function(i, ele){
                var $ele = jQuery(ele);
                $ele.text($ele.text().replace(/\d/g, function(a,n){
                    return index + 2;
                }));
            });

        });

        return false;
    });


    jQuery('body').on('click', '.auto-loss-form__add-witness-link', function(){
        var get = { };

        get.witness_count = witnessCount;

        jQuery.get('/api/add-witness', get, function(response){

            jQuery('.auto-loss-form__witness-container').append(response);
            jQuery('.text-field--phone').mask('000-000-0000');
            witnessCount++;
        });

        return false;
    });


    jQuery('body').on('click', '.auto-loss-form__remove-witness-button', function(e){
        e.preventDefault();
        jQuery(this).closest('.auto-loss-form__new-witness-container').remove();
        witnessCount--;

        jQuery('.auto-loss-form__new-witness-container').each(function(index, container) {

            var $container = jQuery(container);

            $container.find('.input__text-container').find('.label').each(function(i, ele){
                var $ele = jQuery(ele);
                $ele.text($ele.text().replace(/\d/g, function(a,n){
                    return index + 2;
                }));
            });
        });

        return false;
    });


    jQuery('body').on('submit', '.auto-loss-form__form', function(e){
        e.preventDefault();

        jQuery('.auto-loss-form__submission-message').removeClass('auto-loss-form__submission-message--hidden');
        jQuery('.auto-loss-form__form-container').addClass('auto-loss-form__form-container--hidden');

        return false;
    });
});